import { afterNextRender, DestroyRef, Directive, ElementRef, inject } from '@angular/core';

import { ClarityFlyInTopEdges } from './clarity-fly-in-top-edges.service';

/**
 * Marks an element whose bottom edge every Clarity fly-in starts at. The lowest marked edge is published in viewport
 * pixels as `--eff-clarity-fly-in-inset-block-start` on the document's root element, measured again whenever a marked
 * element or its parent resizes, and removed once the last mark is destroyed. The `ClarityFlyIn` pane,
 * `<eff-clarity-fly-in>` and the System Domain preview fly-in read it with a `0px` fallback.
 */
@Directive({ selector: '[effClarityFlyInTopEdge]' })
export class ClarityFlyInTopEdgeDirective {
	private readonly host: HTMLElement = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
	private readonly edges = inject(ClarityFlyInTopEdges);

	private resizeObserver: ResizeObserver | null = null;

	constructor() {
		afterNextRender(() => {
			this.edges.add(this.host);
			this.observe();
		});

		inject(DestroyRef).onDestroy(() => {
			this.resizeObserver?.disconnect();
			this.edges.remove(this.host);
		});
	}

	private observe(): void {
		if (typeof ResizeObserver === 'undefined') {
			return;
		}

		this.resizeObserver = new ResizeObserver(() => this.edges.publish());
		this.resizeObserver.observe(this.host);

		if (this.host.parentElement !== null) {
			this.resizeObserver.observe(this.host.parentElement);
		}
	}
}
